export interface CM {
    id: string;
    wellStringId: string;
    platformShortName: string;
    platformLongName: string;
    fieldShortName: string;
    fieldLongName: string;
    wellShortName: string;
    wellLongName: string;
    stringShortName: string;
    stringLongName: string;
    stringIndicatorShortName: string;
    wellProductionStatus: string;
    planDate: string | null;
    remark: string | null;
    failureDate: string;
    category: string;
    inputDate: string;
}